import { BaseContainerModel } from "../../base-container.model";
import { bl_alg_cc_login_subject_skill_link_RowClass } from "../../../dbschema";

export class LoginSubjectSkillLinkContainerModel extends BaseContainerModel{
  bl_alg_cc_login_subject_skill_link: bl_alg_cc_login_subject_skill_link_RowClass = new bl_alg_cc_login_subject_skill_link_RowClass();
}
